<!--
 * @FileDescription:
 * @version: 2.0
 * @Author: 史琪琪
 * @Date: 2024-01-17 17:07:32
 * @LastEditors: 史琪琪
 * @LastEditTime: 2024-01-17 17:07:32
-->
<template>
  <e-dialog
    dialog-title="易派客隐私协议"
    :center-dialog-visible="visible"
    popup-width="800px"
    :show-btn="false"
    :modal-append-to-body="false"
    :show-close-btn="true"
    :close-model="false"
    @resetPopupData="$emit('close')"
  >
    <div class="body">
      <div class="scroll">
        <div class="box_text" v-html="privacyAgreement"></div>
      </div>
    </div>
  </e-dialog>
</template>

<script>
import { privacyAgreement } from '@/assets/js/cerword.js';
import EDialog from '../common/e-dialog.vue';

export default {
  components: { EDialog },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      privacyAgreement,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .box_text {
  p {
    text-indent: 28px;
  }
  a {
    color: #2587ff;
  }
  .link-a {
    margin-left: 28px;
    display: block;
  }
}
</style>
